import { Box, CircularProgress, Container, Grid, Tab, Tabs, Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import queryString from "query-string";
import React, { memo, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import FindClientGroup from "../../components/Frequents/FindClientGroup";
import JournalAccordion from "./JournalAccordion.js";
import StamDataAccordion from "./StamDataAccordion.js";
import StamJournalAccordion from "./StamJournalAccordion.js";
import Upcoming from "./Upcoming.js";

import API, { getJournalsFromClient, getTherapistAzureContainer } from "../../actions";

import "react-day-picker/lib/style.css";
import Invoice from "../Invoice/Invoice.js";
import { DateSelectorDialog } from "./DateSelectorDialog.js";
import { SaveMergedInvoiceDialog } from "./SaveMergedInvoiceDialog.js";
import { Close } from "@material-ui/icons";
import { StorageIndicator } from "../StorageIndicator/StorageIndicator.jsx";
import { DialogDownload } from "../UploadImage/DialogPopups.jsx";

import { downloadJournalImagesAsZip, getSASToken } from "../UploadImage/AzureStorage.service.js";

import azureStorageEnvVar from "../../constants/AzureStorageEnvironmentVariable";

const CustomTabPanel = memo(props => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}>
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
});

export default props => {
    const therapist = useSelector(state => state.data.therapist);

    const [clients, setClients] = useState([]);

    const [journals, setJournals] = useState([]);
    const [stamJournal, setStamJournal] = useState([]);
    const [stamJournalUpdate, setStamJournalUpdate] = useState(null);

    const [upComing, setUpcoming] = useState([]);

    const [clickedClient, setClickedClient] = useState(null);
    const [expanded, setExpanded] = useState(null);

    const [openDeleteClient, setOpenDeleteClient] = useState(false);
    const [openMergeInvoice, setOpenMergeInvoice] = useState(false);
    const [canEditData, setCanEditData] = useState(true);
    const [bookings, setBookings] = useState([]);
    const [loading, setLoading] = useState(false);

    const [uploadInDrive, setUploadInDrive] = useState(JSON.parse(localStorage.getItem("isGoogleUpload")));

    const uploadToggle = () => {
        setUploadInDrive(val => !val);
        localStorage.setItem("isGoogleUpload", !uploadInDrive);
    };

    const [downloadData, setDownloadData] = useState([]);
    const [downloadPopup, setDownloadPopup] = useState(false);
    const [isImageLoading, setIsImageLoading] = useState(false);
    const handleCloseDownload = () => {
        setDownloadData([]);
        setDownloadPopup(false);
        setIsImageLoading(false);
    };
    const handleOnClick = fileName => {
        const newDownloadData = downloadData.map(file =>
            file.imageName === fileName ? { ...file, isChecked: !file.isChecked } : file
        );
        setDownloadData(newDownloadData);
    };
    const handleDownloadData = async () => {
        const selectedImageNames = downloadData
            .filter(file => file.isChecked)
            .filter(file => !file.isFromGoogle)
            .map(file => file.imageName);
        const googleFiles = [];

        await downloadJournalImagesAsZip(therapist.id, clickedClient?.id, selectedImageNames, googleFiles);

        handleCloseDownload();
    };
    const generateJournalImageData = async () => {
        setDownloadPopup(true);
        setIsImageLoading(true);

        const { AZURE_STORAGE_URL, RESIZED_IMG_PREFIX, CLIENT_PREFIX } = azureStorageEnvVar;

        const [journalsData, therapistContainer] = await Promise.all([
            getJournalsFromClient(clickedClient.id),
            getTherapistAzureContainer(therapist.id)
        ]);
        const sasToken = await getSASToken(therapistContainer);

        const baseUrl = `${AZURE_STORAGE_URL}/${therapistContainer}/${CLIENT_PREFIX}_${clickedClient?.id}/${RESIZED_IMG_PREFIX}`;

        const dataJournal = [];

        if (journalsData?.payload?.journals) {
            for (const journal of journalsData.payload.journals) {
                const downloadJournalData = [];

                if (journal.imagesName) {
                    const azureData = journal.imagesName.split(",").map(fileName => ({
                        imageName: fileName,
                        isChecked: false,
                        imageUrl: `${baseUrl}_${fileName}?${sasToken}`
                    }));
                    downloadJournalData.push(...azureData);
                }

                dataJournal.push(...downloadJournalData);
            }
        }
        // Update the download data
        setDownloadData([...dataJournal]);
        setIsImageLoading(false);
    };

    const clickClient = async id => {
        setLoading(true);

        setClients(await API.getClientsFromTherapist());

        const bookings = await API.getBookingsFromClient(id);

        setBookings(bookings);

        let map = [];
        const now = Date.parse(new Date());
        let firstBookingToTimestamp = 0;
        if (bookings.length > 0) {
            firstBookingToTimestamp = bookings[0].to;
        }

        await Promise.all(
            bookings.map(item => {
                if (firstBookingToTimestamp > item.to) {
                    firstBookingToTimestamp = item.to;
                }
                if (item.from < now) return "";
                return map.push(item);
            })
        );

        const update = [];
        const stam = await API.getCustomFieldsFromClientIsNotJournal(id);
        stam.forEach(felter => {
            if (felter.updatedAt) update.push(Date.parse(felter.updatedAt));
            if (felter.comments && felter.comments.length > 0) {
                for (const comment of felter.comments) {
                    if (comment.updatedAt) update.push(Date.parse(comment.updatedAt));
                }
            }
        });
        if (update.length >= 1) setStamJournalUpdate(Math.max(...update));

        setStamJournal(stam);
        // console.log('stamJournal', stam);
        setJournals(await API.getJournalsFromClient(id));
        setUpcoming(map);
        setClickedClient(await API.getClientData(id));
        setKey(key => key + 1);
        if (firstBookingToTimestamp > 0) {
            setCanEditData(getCanEditDataStatus(firstBookingToTimestamp));
        }
        setLoading(false);
    };
    const getCanEditDataStatus = endTime => {
        return new Date().getTime() < +endTime + 86400000;
    };

    useEffect(() => {
        (async () => {
            if (!props.location.search) setClients(await API.getClientsFromTherapist());
            if (props.location.search) {
                const clientId = queryString.parse(props.location.search).id;
                const journalId = queryString.parse(props.location.search).journalId;
                setExpanded(journalId);
                await clickClient(clientId);
            }
        })();
    }, [props.location.search]);

    const [selectedBookigIds, setSelectedBookingIds] = useState();
    const [selectedToDate, setSelectedToDate] = useState(null);
    const [selectedFromDate, setSelectedFromDate] = useState(null);

    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const [alreadySelectedInvoices, setAlreadySelectedInvoices] = useState([]);
    const [oldInvoiceId, setOldInvoiceId] = useState();

    const openMergeInvoiceDialogForEdit = ({ fromDate, toDate, alreadySelected, id }) => {
        const filtered = bookings.filter(booking => {
            const bookingDate = parseInt(booking.from);
            return bookingDate >= fromDate && bookingDate <= toDate;
        });

        const selectedBookingIds = filtered.map(fb => fb.id);
        console.log({ selectedBookingIds });

        setOldInvoiceId(id);
        setSelectedToDate(new Date(toDate));
        setSelectedFromDate(new Date(fromDate));
        setAlreadySelectedInvoices(alreadySelected);
        setSelectedBookingIds(selectedBookingIds);
    };
    const [key, setKey] = useState(0);

    if (!clients) return <></>;

    return (
        <Container style={{ overflowY: "auto", paddingBottom: "10px" }}>
            <StorageIndicator uploadToggle={uploadToggle} uploadInDrive={uploadInDrive} />
            <div style={{ marginTop: "20px", marginBottom: "20px" }}>
                <FindClientGroup
                    clients={clients}
                    clickedClient={clickedClient}
                    changeValue={async value => await clickClient(value.id)}
                    journals={true}
                    isHideDesciption={true}
                />
            </div>
            {clickedClient ? (
                loading ? (
                    <Box
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "300px",
                            width: "100%"
                        }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <>
                        <StamDataAccordion
                            clients={clients}
                            key={clickedClient.id + "stamdata"}
                            clickedClient={clickedClient}
                            expanded={expanded}
                            uploadInDrive={uploadInDrive}
                            expand={() => setExpanded(expanded === "stamdata" ? null : "stamdata")}
                        />
                        <StamJournalAccordion
                            canEditData={canEditData}
                            clickedClient={clickedClient}
                            stamJournal={stamJournal}
                            stamJournalUpdate={stamJournalUpdate || clickedClient.createdAt}
                            expanded={expanded}
                            key={clickedClient.id + "stamjournal"}
                            expand={() => setExpanded(expanded === "stamjournal" ? null : "stamjournal")}
                        />

                        {!journals ||
                            journals.map((journal, index) => {
                                return (
                                    <JournalAccordion
                                        key={journal.id}
                                        canEditData={getCanEditDataStatus(journal.to)}
                                        journal={journal}
                                        index={index}
                                        uploadInDrive={uploadInDrive}
                                        expanded={expanded}
                                        expand={() => {
                                            setExpanded(expanded === journal.id ? null : journal.id);
                                        }}
                                        clickedClient={clickedClient}
                                    />
                                );
                            })}
                        {upComing ? <Upcoming bookings={upComing} /> : <></>}
                        <Button
                            variant="contained"
                            color="secondary"
                            style={{ marginTop: "10px" }}
                            onClick={() => setOpenDeleteClient(true)}>
                            Slet al data
                        </Button>
                        <Button
                            variant="outlined"
                            color="primary"
                            style={{ marginTop: "10px", marginLeft: "10px" }}
                            onClick={() => setOpenMergeInvoice(true)}>
                            opret samlet opgørelse for behandlingsforløb
                        </Button>
                        <Button
                            variant="secondary"
                            // journals
                            onClick={generateJournalImageData}
                            style={{
                                marginTop: "10px",
                                marginLeft: "10px",
                                textDecorationLine: "underline",
                                textUnderlineOffset: "8px"
                            }}>
                            Download billeder
                        </Button>
                        {downloadPopup && (
                            <DialogDownload
                                downloadData={downloadData}
                                isImageLoading={isImageLoading}
                                handleOnImageClick={handleOnClick}
                                handleDownloadData={handleDownloadData}
                                handleCloseDownload={handleCloseDownload}
                            />
                        )}
                        <DateSelectorDialog
                            bookings={bookings}
                            setSelectedBookingIds={setSelectedBookingIds}
                            openMergeInvoice={openMergeInvoice}
                            setOpenMergeInvoice={setOpenMergeInvoice}
                            selectedToDate={selectedToDate}
                            selectedFromDate={selectedFromDate}
                            setSelectedToDate={setSelectedToDate}
                            setSelectedFromDate={setSelectedFromDate}
                        />

                        <Typography variant="h6" style={{ marginTop: "60px", marginBottom: "20px" }}>
                            Samlet opgørelser
                        </Typography>

                        <Tabs
                            textColor="primary"
                            indicatorColor="primary"
                            style={{ marginBottom: "20px" }}
                            value={value}
                            onChange={handleChange}
                            aria-label="basic tabs example">
                            <Tab label="Alle fakturaer" value={0} />
                            <Tab label="Samlet  opgørelser" value={1} />
                        </Tabs>

                        <CustomTabPanel value={value} index={0}>
                            <Invoice
                                key={key}
                                bookingIds={bookings.map(b => b.id)}
                                // clientId={clickedClient.id}
                                onEdit={({ ids, invoice, start, end }) => {
                                    openMergeInvoiceDialogForEdit({
                                        fromDate: start,
                                        toDate: end,
                                        alreadySelected: ids,
                                        id: invoice.id
                                    });
                                    console.log({ ids });
                                }}
                            />
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={1}>
                            <Invoice
                                key={key}
                                clientId={clickedClient.id}
                                onEdit={({ ids, invoice, start, end }) => {
                                    openMergeInvoiceDialogForEdit({
                                        fromDate: start,
                                        toDate: end,
                                        alreadySelected: ids,
                                        id: invoice.id
                                    });
                                }}
                            />
                        </CustomTabPanel>

                        {selectedBookigIds?.length > 0 && (
                            <SaveMergedInvoiceDialog
                                selectedBookigIds={selectedBookigIds}
                                setSelectedBookingIds={setSelectedBookingIds}
                                bookings={bookings}
                                clientId={clickedClient.id}
                                selectedToDate={selectedToDate}
                                selectedFromDate={selectedFromDate}
                                alreadySelectedInvoices={alreadySelectedInvoices}
                                setAlreadySelectedInvoices={setAlreadySelectedInvoices}
                                oldInvoiceId={oldInvoiceId}
                                setOldInvoiceId={setOldInvoiceId}
                                setOpenMergeInvoice={setOpenMergeInvoice}
                                setKey={setKey}
                                setSelectedToDate={setSelectedToDate}
                                setSelectedFromDate={setSelectedFromDate}
                            />
                        )}
                        <Dialog
                            open={openDeleteClient}
                            onClick={() => setOpenDeleteClient(false)}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description">
                            <DialogTitle id="alert-dialog-title">{"Du er ved at slette klienten"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Når du sletter klienten, slettes alt gemt data på pågældende klient. Er du sikker på
                                    denne handling?
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => setOpenDeleteClient(false)} color="primary">
                                    Nej
                                </Button>
                                <Button
                                    onClick={async () => {
                                        await API.deleteClient(clickedClient.id);
                                        setOpenDeleteClient(false);
                                        setClickedClient(null);
                                    }}
                                    color="primary"
                                    autoFocus>
                                    Ja
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </>
                )
            ) : (
                <></>
            )}
        </Container>
    );
};
